import { currentDevice } from '../../core/utils/currentDevice'
import { createBottomSheet } from '../../shared/bottom_sheet/bottom_sheet'
import Modal from '../../shared/modal/modal'

const MODAL_BADGE_DATA_ATTR_NAME = 'modalBadgeId'
const MODAL_ALL_BADGES_DATA_ATTR_NAME = 'modalAllBadgesId'

function init() {
  const bottomSheetInstances = {}

  document.addEventListener('click', function (e) {
    const element = e.target
    const hasBadgeId = MODAL_BADGE_DATA_ATTR_NAME in element.dataset
    const hasAllBadgesId = MODAL_ALL_BADGES_DATA_ATTR_NAME in element.dataset

    if (!element || (!hasBadgeId && !hasAllBadgesId)) return

    const dataAttr = hasBadgeId ? MODAL_BADGE_DATA_ATTR_NAME : MODAL_ALL_BADGES_DATA_ATTR_NAME

    const modalId = element.dataset[dataAttr]

    if (!modalId) return

    if (currentDevice.isMobile) {
      if (!bottomSheetInstances[modalId]) {
        bottomSheetInstances[modalId] = createBottomSheet({ sheetId: modalId })
      }
      bottomSheetInstances[modalId].show()
    } else {
      Modal.show(modalId, {
        onShow: () => {
          ScrollLock.on()
        },
        onClose: () => {
          ScrollLock.off()
        },
        awaitCloseAnimation: true,
      })
    }
  })
}

init()
